export const decodeTextHelper = (text: string) => {
  try {
    return decodeURIComponent(text);
  } catch (err: any) {
    return text;
  }
};

export const getStyles = url => {
  return new Promise(function (resolve, reject) {
    import(`${url}`).then(async style => {
      resolve(style);
    });
  });
};
